import React, { FunctionComponent } from 'react'
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

interface DeleteQuickKeyLayoutModalProps {
  deleteLayout: () => void
  onClose: () => void
}

export const DeleteQuickKeyLayoutModal: FunctionComponent<DeleteQuickKeyLayoutModalProps> = ({
  onClose,
  deleteLayout,
}) => {
  return (
    <Modal size="small" onClose={onClose}>
      <ModalHeader>
        <T _str="You are about to delete this Quick Key Layout" />
      </ModalHeader>
      <ModalContent>
        <T _str="Other registers and outlets will no longer be able to use this layout in the future." />
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button variant="supplementary" onClick={onClose}>
            <T _str="Don’t Delete" />
          </Button>
          <Button variant="no" onClick={deleteLayout}>
            <T _str="Delete" />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
